import { isEmpty } from 'lodash'
import { API_ERROR_MAP } from '../main/types'
import apiErrorToErrorMessage from './apiErrorToErrorMessage'

// Redux-form processes and returns form submission errors as follows:
//  + If form validation errors were raised without any external interaction
//    (e.g., an API call) then "errors" will be set with a property for each
//    validation error and "submitError" will be undefined.
//  + If form validation errors were raised due to custom validations generating
//    a SubmissionError against a form field, both "errors" and "submitError"
//    will be defined. This case is differentiated by the content of the
//    SubmissionError (meta.error.name !== 'HttpError').
//  + If external errors were raised (e.g. API/HTTP failure), "errors._error" is
//    set and "submitError" will be defined with a SubmissionError whose
//    "meta.error" property contains the HttpError.
//
// This function returns the overall form error (errors._error) or a generic
// validation message when validation failed; otherwise it returns the result of
// apiErrorToErrorMessage(errors._error) for external errors.
export default function errorMessageFromFormErrors(errors, submitError) {
  if (isEmpty(errors)) return null

  const hasValidationErrors = !isEmpty(errors) && isEmpty(submitError)
  const hasCustomValidationErrors =
    submitError?.meta?.error?.name !== 'HttpError'
  const { _error: formWideError } = errors

  if (hasValidationErrors || hasCustomValidationErrors) {
    return (
      formWideError ??
      'Please review the information provided and correct all form errors'
    )
  }

  const mapped = apiErrorToErrorMessage(formWideError)
  return mapped !== API_ERROR_MAP.UNKNOWN_ERROR ? mapped : formWideError
}
